import { firestore } from '../../utilities/firebase'
import getUserProfile from './internal'

export default getUserProfile(firestore)



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfile/index.js